import { APP_LOGO } from "assets";
import { navLinks } from "../../navLinks";
import { NavLink } from "react-router-dom";
import usePageNavbar from "./useNavbar";
import { ReactSVG } from "react-svg";
import { motion } from "framer-motion";
import Sidebar from "../Sidebar";

const PageNavbar = ({ isHomePage }) => {
  const { getNavLinkClassName, activeNavLinkId, screens } = usePageNavbar();

  return (
    <nav className={`page-navbar ${isHomePage ? "home-page" : ""}`}>
      <div className="page-navbar-inner container">
        <ReactSVG src={APP_LOGO} className="app-logo" />
        {screens.md ? (
          <div className="nav-links">
            {navLinks.map((navLink) => (
              <NavLink
                className={getNavLinkClassName}
                key={navLink.title}
                end
                to={navLink.path}
              >
                {navLink.title}
                {activeNavLinkId === navLink.id && (
                  <motion.div
                    className="underline"
                    layoutId="underline"
                    style={{ originY: "0px" }}
                  />
                )}
              </NavLink>
            ))}
          </div>
        ) : (
          <Sidebar />
        )}
      </div>
    </nav>
  );
};

export default PageNavbar;
